import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import { useQuery } from 'urql';
import Spinner from '../icons/Spinner';
import css from './Press.module.scss';
import Block from './Block';
import { getPressBlocks } from './queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Press = function Press(_ref) {
  var contactEmail = _ref.contactEmail,
      title = _ref.title;

  var _useQuery = useQuery({
    query: getPressBlocks
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  return /*#__PURE__*/_jsx("div", {
    className: css.root,
    children: /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [/*#__PURE__*/_jsx("h1", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsxs("div", {
        className: css.contact,
        children: ["Contact us directly:\xA0", /*#__PURE__*/_jsx("a", {
          href: "mailto:".concat(contactEmail),
          children: contactEmail
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: css.separator
      }), fetching && /*#__PURE__*/_jsx("div", {
        className: css.loading,
        "aria-busy": "true",
        children: /*#__PURE__*/_jsx(Spinner, {
          white: true
        })
      }), !fetching && data && /*#__PURE__*/_jsx("div", {
        className: css.blocksContainer,
        children: data.pressBlocks.edges.map(function (_ref2) {
          var node = _ref2.node;
          return /*#__PURE__*/_jsx(Block, _objectSpread({}, node), node.id);
        })
      })]
    })
  });
};

Press.propTypes = {
  contactEmail: PropTypes.string,
  pressBlocks: PropTypes.arrayOf(PropTypes.shape()),
  summary: PropTypes.string,
  title: PropTypes.string
};
Press.defaultProps = {
  contactEmail: '',
  pressBlocks: [],
  summary: '',
  title: ''
};
export default Press;